// extracted by mini-css-extract-plugin
module.exports = {"submitContainer":"styles_submitContainer__K1dT6","backButton":"styles_backButton__3cL1E","submitButton":"styles_submitButton__1s6RR"};